import React, { Component } from "react";
import { createPortal } from "react-dom";
import styles from "./PopUp.module.scss";
import { Transition } from 'react-transition-group';
import { ReactComponent as BLogo } from "../../assets/SVGs/logos/b-logo.svg";

const duration = 0.25;
const timeout = 200;

const defaultStyle = {
	transition: `right ${duration}s ease-out`,
	right: '-100%',
};

const transitionStyles = {
	entering: {right: '100px'},
	entered:  {right: '25px'},
	exiting:  {right: '50px'},
	exited:   {right: '-100%'},
};


class PopUp extends Component {
	constructor() {
		super();
		this.state = {
			open: false,
		};
	}

	render() {
		const rootDOM = document.getElementById('root');
		return createPortal(
			<Transition
				in={this.props.open !== undefined ? this.props.open : this.state.open}
				timeout={timeout}
			>
				{tState => (
					<div
						className={styles.popUp}
						style={{
							...defaultStyle,
							...transitionStyles[tState]
						}}
					>
						{
							this.props.logo ?
								<div className={styles.logo}>
									<BLogo />
								</div>
							:
								<></>
						}
						<div className={styles.content}>
							{
								this.props.title ?
									<div className={styles.title}>
										{this.props.title}
									</div>
								:
									<></>
							}
							<div className={styles.text}>
								{this.props.children || this.props.text || ""}
							</div>
						</div>
					</div>
				)}
			</Transition>,
			rootDOM
		)
	}
}

export default PopUp;